/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditDowntimeStatus } from '../../models/edit-downtime-status';

export interface GetEditDowntimeStatus$Params {
  downtimeId: number;
}

export function getEditDowntimeStatus(http: HttpClient, rootUrl: string, params: GetEditDowntimeStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<EditDowntimeStatus>> {
  const rb = new RequestBuilder(rootUrl, getEditDowntimeStatus.PATH, 'get');
  if (params) {
    rb.path('downtimeId', params.downtimeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditDowntimeStatus>;
    })
  );
}

getEditDowntimeStatus.PATH = '/api/v1/Downtimes/EditDowntimeStatus/{downtimeId}';
